import i18n from '@/plugins/i18n';
import utils from '@/utils/functions';
import store from '@/state/store';

const staticData = () => {
  store.state.companySettings;
  const shouldHideCpa = utils.checkOcultarCpa();

  const columns = [
    {
      key: 'name',
      label: i18n.t('Name'),
      custom_class: 'text-left'
    },
    {
      key: 'sub_brand_name',
      label: i18n.t('Sub Brand'),
      custom_class: 'text-left'
    },
    {
      key: 'active_customers_count',
      label: i18n.t('Users'),
      custom_class: 'text-center'
    },
    {
      key: 'reward_accumulative',
      label: i18n.t('Comissão'),
      formatter: utils.formatMoneyFloat,
      custom_class: 'text-center'
    },
    {
      key: 'reward_total',
      label: i18n.t('Valor a Pagar'),
      formatter: utils.formatMoneyFloat,
      custom_class: 'text-center'
    },
    {
      key: 'current_ggr',
      label: i18n.t('GGR'),
      formatter: utils.formatMoneyFloat,
      custom_class: 'text-center carryover-column'
    },
    {
      key: 'previous_period_ggr',
      label: i18n.t('Previous month GGR'),
      formatter: utils.formatMoneyFloat,
      custom_class: 'text-center carryover-column'
    },
    {
      key: 'net_ggr_balance',
      label: i18n.t('GGR balance for next month'),
      formatter: utils.formatMoneyFloat,
      custom_class: 'text-center carryover-column'
    },
    {
      key: 'commission_ggr_base',
      label: i18n.t('Commission GGR base'),
      formatter: utils.formatMoneyFloat,
      custom_class: 'text-center carryover-column'
    },
    {
      key: 'admin_fee',
      label: i18n.t('Taxa Admin.'),
      formatter: utils.formatMoneyFloat,
      custom_class: 'text-center carryover-column'
    },
    {
      key: 'net',
      label: i18n.t('Líquido'),
      formatter: utils.formatMoneyFloat,
      custom_class: 'text-center carryover-column'
    },
    {
      key: 'closing_ggr_balance',
      label: i18n.t('Balance for next month'),
      formatter: utils.formatMoneyFloat,
      custom_class: 'text-center carryover-column'
    }
  ];

  if (!shouldHideCpa) {
    columns.push(
      {
        key: 'reward_mark_count',
        label: i18n.t('Qty. CPA'),
        custom_class: 'text-center'
      },
      {
        key: 'reward_mark',
        label: i18n.t('CPA'),
        formatter: utils.formatMoneyFloat,
        custom_class: 'text-center'
      }
    );
  }

  return {
    columns
  };
};

export default staticData;
